"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("../Button"));
var _StyledTableHeader = require("./StyledTableHeader");
var _ykbStyledComponents = require("../ykb-styled-components");
var _LocaleContext = require("../locales/LocaleContext");
var _default2 = _interopRequireDefault(require("../locales/default"));
var _TableHeaderGhostButton = _interopRequireDefault(require("./TableHeaderGhostButton"));
var _More = _interopRequireDefault(require("./More"));
var _PredefinedButtonHOC = _interopRequireDefault(require("./PredefinedButtonHOC"));
var _Search = _interopRequireDefault(require("./Search"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var TableHeader = /*#__PURE__*/function (_React$Component) {
  function TableHeader() {
    (0, _classCallCheck2.default)(this, TableHeader);
    return _callSuper(this, TableHeader, arguments);
  }
  (0, _inherits2.default)(TableHeader, _React$Component);
  return (0, _createClass2.default)(TableHeader, [{
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        title = _this$props.title,
        onExcelExport = _this$props.onExcelExport,
        onCsvExport = _this$props.onCsvExport,
        onPdfExport = _this$props.onPdfExport,
        onRefresh = _this$props.onRefresh,
        onAdd = _this$props.onAdd,
        extra = _this$props.extra,
        more = _this$props.more,
        maximized = _this$props.maximized,
        search = _this$props.search;
      return /*#__PURE__*/_react.default.createElement(_LocaleContext.LocaleReceiver, {
        componentName: "TableHeader",
        defaultLocale: _default2.default.TableHeader
      }, function (_localeCode, locale) {
        var PredefinedButton = (0, _PredefinedButtonHOC.default)(locale);
        return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
          return /*#__PURE__*/_react.default.createElement(_StyledTableHeader.StyledTableHeader, {
            theme: theme
          }, /*#__PURE__*/_react.default.createElement(_StyledTableHeader.StyledTitle, {
            $onlyChild: !(extra || onExcelExport || onRefresh || onAdd || onCsvExport || onPdfExport || more)
          }, title), /*#__PURE__*/_react.default.createElement(_StyledTableHeader.StyledButtonContainer, null, !maximized && search && /*#__PURE__*/_react.default.createElement(_Search.default, (0, _extends2.default)({}, search, {
            locale: locale
          })), !maximized && extra || null, !maximized && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(PredefinedButton, (0, _extends2.default)({}, _this.props, {
            name: "onExcelExport"
          })), /*#__PURE__*/_react.default.createElement(PredefinedButton, (0, _extends2.default)({}, _this.props, {
            name: "onCsvExport"
          })), /*#__PURE__*/_react.default.createElement(PredefinedButton, (0, _extends2.default)({}, _this.props, {
            name: "onPdfExport"
          })), /*#__PURE__*/_react.default.createElement(PredefinedButton, (0, _extends2.default)({}, _this.props, {
            name: "onRefresh"
          })), /*#__PURE__*/_react.default.createElement(PredefinedButton, (0, _extends2.default)({}, _this.props, {
            name: "onAdd"
          }))), /*#__PURE__*/_react.default.createElement(PredefinedButton, (0, _extends2.default)({}, _this.props, {
            name: "onMaximize"
          })), !maximized && more && /*#__PURE__*/_react.default.createElement(_More.default, (0, _extends2.default)({}, more, {
            size: _this.props.size
          }))));
        });
      });
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(TableHeader, "GhostButton", _TableHeaderGhostButton.default);
TableHeader.propTypes = {
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  onExcelExport: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.element]),
  onCsvExport: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.element]),
  onPdfExport: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.element]),
  onRefresh: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.element]),
  onAdd: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.element]),
  onMaximize: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.element]),
  maximized: _propTypes.default.bool
};
TableHeader.defaultProps = {
  title: ' ',
  maximized: false
};
var _default = exports.default = TableHeader;